<template>
  <div class="roaming-containBox">
    <div
      class="roaming-containBox-list"
      v-show="!isEdit">
      <el-button
        v-if="isChecked('Project.Single.SceneRoam.Operate')"
        class="primary-btn primary-ang-btn addRoaming"
        type="primary"
        size="small"
        :disabled="isRunRoam"
        @click="addPath"
        ><i class="el-icon-plus"></i> 新建漫游</el-button
      >
      <div
        class="roaming-content"
        v-if="roamingData?.length">
        <div
          class="roaming-content-item"
          v-for="(item, index) in roamingData"
          :key="index">
          <div class="roaming-content-item-title">
            <div
              class="roaming-content-item-title-text"
              :title="item.name">
              {{ item.name }}
            </div>
            <div
              class="roaming-content-item-title-opera"
              v-if="isChecked('Project.Single.SceneRoam.Operate')">
              <el-button
                type="primary"
                size="small"
                plain
                :disabled="!item.isPlay || item.selfRoamIsRun"
                class="normal-btn primary-ang-btn"
                @click="editRoamingViewPort(item)"
                >编辑</el-button
              >
              <el-button
                :disabled="!item.isPlay || item.selfRoamIsRun"
                @click="delRoaming(item)"
                size="small"
                plain
                class="normal-btn primary-ang-btn"
                >删除</el-button
              >
            </div>
          </div>
          <div class="roaming-content-item-play">
            <div class="roaming-content-item-play-btn-box">
              <el-button
                size="small"
                :disabled="!item.isHasViewPorts || item.selfRoamIsRun"
                plain
                @click="item.isPlay ? playRoam(item) : pauseRoam(item)"
                class="normal-btn primary-ang-btn"
                >{{ item.isPlay ? '播放' : '暂停' }}</el-button
              >
              <el-button
                :disabled="!item.isHasViewPorts || item.selfRoamIsRun"
                size="small"
                plain
                @click="stopRoam(item)"
                class="normal-btn primary-ang-btn"
                >停止</el-button
              >
              <el-input
                v-if="isChecked('Project.Single.SceneRoam.Operate')"
                @change="changeRoamName(item)"
                type="number"
                @input="disabledInput(item)"
                class="input-primary"
                :disabled="!item.isPlay || item.selfRoamIsRun"
                v-model="item.speed"
                placeholder="请输入"></el-input>
              <span
                class="unit"
                v-if="isChecked('Project.Single.SceneRoam.Operate')">
                <el-select
                  :disabled="!item.isPlay || item.selfRoamIsRun"
                  @change="changeRoamName(item)"
                  class="primary-select"
                  v-model="item.speedUnit"
                  placeholder="请选择"
                  :popper-append-to-body="false">
                  <el-option
                    v-for="(item, index) in speedUnitList"
                    :title="item.label"
                    :key="index"
                    :label="item.label"
                    :value="item.value" />
                </el-select>
              </span>
            </div>
            <div
              class="roaming-content-item-play-speed-box"
              v-if="!isChecked('Project.Single.SceneRoam.Operate')">
              漫游速度：{{ getRoamSpeed(item) }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="emptyData"
        v-else>
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <span
              class="empty-text"
              v-if="isChecked('Project.Single.SceneViewPort.Operate')">
              暂无漫游路径，您可点击
              <span class="newPath">新建漫游按钮</span>
              创建
            </span>
            <span
              v-else
              class="empty-text"
              >暂无漫游路径
            </span>
          </template>
        </bj-empty>
      </div>
    </div>
    <div
      class="roaming-containBox-edit"
      v-show="isEdit && isChecked('Project.Single.SceneRoam.Operate')">
      <editRoaming
        @rebackRoaming="rebackRoaming"
        ref="editRoamingRefs" />
    </div>
  </div>
</template>

<script>
import editRoaming from './editRoaming.vue'

import { Store } from '@/utils/store'
import {
  getRoamList,
  deleteRoam,
  editRoamNameAndSpeed
} from '@/service/roam/index.js'
import { roamingPlay, roamingStop, roamingPause } from './'
import { getCameraViewAngle } from '@/utils/engineUtils'

export default {
  data() {
    return {
      roamingData: [],
      speedUnitList: [
        {
          label: 'm/s',
          value: 'Meter'
        },
        {
          label: 'km/s',
          value: 'Kilometer'
        }
      ],
      isEdit: false,
      pauseInfoList: [],
      isRunRoam: false,
      isPauseId: '',
      playRoamItem: {}
    }
  },
  components: {
    editRoaming
  },
  computed: {
    getSceneId() {
      return this.$route.query.sceneId
    }
  },
  methods: {
    disabledInput(item) {
      if (item.speed.toString().length > 15) {
        this.$nextTick(() => {
          item.speed = item.speed.toString().slice(0, 15)
        })
      }

      // 自动去除前导零（可选）
      if (item.speed.toString() > 1 && item.speed.toString().startsWith('0')) {
        this.$nextTick(() => {
          item.speed = item.speed.toString().replace(/^0+/, '') || '0'
        })
      }

      const dotIndex = item.speed.indexOf('.')
      // 截断超过两位的小数
      if (dotIndex !== -1) {
        const decimalPart = item.speed.substring(dotIndex + 1)
        if (decimalPart.length > 2) {
          item.speed = item.speed.substring(0, dotIndex + 3)
        }
      }
    },
    // 修改路径名称
    async changeRoamName(item) {
      if (!item.speed) {
        return
      }
      const roamInfo = {
        name: item.name,
        sceneRoamId: item.sceneRoamId,
        speed: item.speed,
        speedUnit: item.speedUnit
      }
      const { isSuccess, errMsg } = await editRoamNameAndSpeed(roamInfo)
      if (!isSuccess) {
        this.$message.error(errMsg)
      } else {
        // this.getRoamList(item)
      }
    },
    // 获取列表最大索引
    findMaxIndex(arr = []) {
      // 容错处理：空数组直接返回初始序号
      if (!arr.length) return 1
      // 使用正则提取数字，避免 split 误分割
      const pattern = /漫游(\d+)/
      let max = -Infinity

      // 单次遍历同时完成有效值过滤和最大值计算
      for (const { name } of arr) {
        const match = name?.match(pattern)
        const num = match ? parseInt(match[1], 10) : NaN
        if (!isNaN(num) && num > max) {
          max = num
        }
      }
      return max !== -Infinity ? max + 1 : 1
    },
    async getRoamList(item) {
      const data = await getRoamList(this.getSceneId)

      if (data?.isSuccess) {
        this.roamingData =
          data?.data.map(item => {
            return {
              ...item,
              isPlay: true,
              selfRoamIsRun: false
            }
          }) ?? []
      } else {
        this.roamingData = []
        this.$message.error(data.errMsg)
      }
    },

    // 获取漫游数据
    async getRoamListViewPort(item) {
      const roamingInfo = await this.$refs.editRoamingRefs.editRoamInfo(
        item.sceneRoamId
      )
      const infoList = roamingInfo.viewPorts.map(item => item.visualAngle)
      const roamSpeedUnit = roamingInfo.speedUnit === 'Meter' ? 1 : 1000
      const totalRoamSpeed = Number(item.speed) * roamSpeedUnit
      return {
        ...roamingInfo,
        totalRoamSpeed,
        viewPorts: infoList
      }
    },

    //开始播放
    async playRoam(item) {
      if (this.isPauseId && this.isPauseId !== item?.sceneRoamId) {
        this.pauseInfoList = []
      }
      this.playRoamItem = item
      this.isPauseId = item.sceneRoamId
      let playRoam
      const roamingInfo = await this.getRoamListViewPort(item)
      if (roamingInfo?.viewPorts?.length === 0) {
        return
      }
      if (!this.pauseInfoList?.length) {
        playRoam = roamingInfo.viewPorts
      } else {
        playRoam = this.pauseInfoList
      }
      item.isPlay = false
      this.isRunRoam = true

      this.roamingData.forEach(list => {
        if (list.sceneRoamId !== item.sceneRoamId) {
          list.selfRoamIsRun = true
        }
      })

      roamingPlay(playRoam, roamingInfo.totalRoamSpeed, item, this.playRoamEnd)
    },

    // 暂停播放
    async pauseRoam(item) {
      const currentIndex = roamingPause()
      const roamingInfo = await this.getRoamListViewPort(item)
      let playRoamList
      if (!this.pauseInfoList?.length) {
        playRoamList = roamingInfo.viewPorts
      } else {
        playRoamList = this.pauseInfoList
      }
      const currentViewPort = getCameraViewAngle()
      item.isPlay = true
      this.isRunRoam = false
      this.roamingData.forEach(list => {
        list.selfRoamIsRun = false
      })
      window.BlackHole3D.Camera.setCamLocateTo(
        JSON.parse(currentViewPort),
        0,
        1
      )
      const cameraPositionList = playRoamList.slice(currentIndex)
      const cameraPositionListInfo = [currentViewPort, ...cameraPositionList]
      this.pauseInfoList = cameraPositionListInfo
    },

    // 漫游播放结束
    playRoamEnd(item) {
      item.isPlay = true
      this.pauseInfoList = []
      this.roamingData.forEach(list => {
        list.selfRoamIsRun = false
      })
      this.isPauseId = ''
      this.isRunRoam = false
    },
    // 停止漫游
    async stopRoam(item) {
      if (!Object.keys(item).length) {
        return
      }
      this.pauseInfoList = []
      this.isPauseId = ''
      item.isPlay = true
      this.isRunRoam = false
      this.roamingData.forEach(list => {
        list.selfRoamIsRun = false
      })
      const roamingInfo = await this.getRoamListViewPort(item)
      roamingStop(roamingInfo.viewPorts)
    },
    getRoamSpeed(roamInfo) {
      let find = this.speedUnitList.find(el => el.value === roamInfo.speedUnit)
      return `${roamInfo.speed}${find.label}`
    },
    addPath() {
      this.$refs.editRoamingRefs?.clearRoamList()
      const roamName = `漫游${this.findMaxIndex(this.roamingData)}`
      const params = { name: roamName, speed: 200 }
      this.$refs.editRoamingRefs.roamingSaveAll(params)
      this.isEdit = true
    },
    delRoaming(item) {
      this.$confirm(`此操作将永久删除当前路径，确认继续吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { isSuccess } = await deleteRoam(item.sceneRoamId)
          if (isSuccess) {
            this.pauseInfoList = []
            this.isPauseId = ''
            this.isRunRoam = false
            this.getRoamList()
          }
        })
        .catch(() => {})
    },
    editRoamingViewPort(item) {
      this.stopRoam(item)
      this.$nextTick(() => {
        this.$refs.editRoamingRefs.editRoamInfo(item.sceneRoamId)
        this.isEdit = !this.isEdit
      })
    },
    rebackRoaming() {
      this.getRoamList()
      this.isEdit = false
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  },
  async mounted() {
    this.getRoamList()
  }
}
</script>

<style scoped lang="less">
@import '@/assets/css/publishSearch.less';

.roaming-containBox {
  padding: 16px;
  padding-top: 8px;
  height: 100%;

  &-edit {
    height: 100%;
  }

  &-list {
    height: 100%;
  }
  .addRoaming {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    :deep(span) {
      display: inline-block;
    }
  }

  .roaming-content {
    margin-top: 8px;
    height: calc(100% - 35px);
    overflow-y: auto;
    &-item {
      // border: 1px solid var(--base-primary-bgColor);
      border-radius: 8px;
      background: var(--roaming-list-bgColor);
      border: 1px solid var(--roaming-list-border-color);

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      &-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--base-bg-dark-color33);
        height: 32px;
        width: 100%;

        &-text {
          font-size: 14px;
          color: var(--roaming-list-title-text-color);
          margin-left: 8px;
          max-width: calc(100% - 82px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &-opera {
          display: flex;
          align-items: center;
          margin-right: 8px;
          :deep(.el-button) {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            padding: 3px 4px;
            display: flex;
            align-items: center;

            span {
              display: inline-block;
            }
          }
        }
      }

      &-play {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 8px 14px 8px;

        &-btn-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          // display: flex;
          // justify-content: flex-start;
          // align-items: center;
          // flex: 1;
          :deep(.el-input__inner) {
            height: 32px !important;
            line-height: 32px !important;
          }

          .unit {
            margin-left: 8px;

            .primary-select {
              :deep(.el-input__icon) {
                line-height: 26px;
              }
            }
          }

          :deep(.el-button) {
            height: 20px;
            font-size: 12px;
            padding: 3px 4px;
            display: flex;
            align-items: center;

            span {
              display: inline-block;
            }
          }

          .input-primary {
            margin: 0 6px;

            :deep(.el-input__inner) {
              height: 32px;
              line-height: 16px;

              &[type='number'] {
                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }

                -moz-appearance: textfield;
              }
            }
          }
        }

        &-speed-box {
          font-size: 12px;
        }
      }
    }
  }

  .emptyData {
    height: calc(100% - 30px);
    display: flex;
    align-items: center;
    justify-content: center;
    .newPath {
      color: var(--empty-text-color);
      font-size: 12px;
      font-weight: 600;
    }
    :deep(.el-empty__image) {
      width: 260px;
    }
  }
}
</style>
